import Layout from '@/layout'
import { checkCfsPermission } from '@/utils/permission'

const hideAgentCommission = checkCfsPermission('AGENT_Commission.SEARCH') && checkCfsPermission('PAGE')
const hideAgentCommissionSettlement = checkCfsPermission('AGENT_COMMISSION_SETTLEMENT.SEARCH') && checkCfsPermission('order')

const agentRouter = {
  path: '/agent',
  component: Layout,
  alwaysShow: true,
  redirect: '/market/agentCommission',
  name: 'agent',
  hidden: false,
  meta: {
    title: 'agentMenu.title', // AGENT
    icon: 'peoples'
  },
  children: [
    {
      path: '/market/agentCommission',
      component: () => import('@/views/spread/agentCommission'),
      name: 'agentCommission',
      meta: {
        title: 'agentMenu.commission_setting', // AGENT分潤設定
        noCache: false
      },
      hidden: hideAgentCommission
    },
    {
      path: '/market/agentCommissionRecord',
      component: () => import('@/views/market/agentCommissionRecord'),
      name: 'agentCommissionRecord',
      meta: {
        title: 'agentMenu.commission_detail', // AGENT分潤明細
        noCache: false
      },
      hidden: hideAgentCommission
    },
    {
      path: '/market/agentCommissionSettlement',
      component: () => import('@/views/market/agentCommissionSettlement'),
      name: 'agentCommissionSettlement',
      meta: { title: 'agentMenu.commission_report', noCache: false }, // AGENT分潤報表
      hidden: hideAgentCommissionSettlement
    },
    {
      path: '/market/agentCommissionEdit',
      component: () => import('@/views/spread/agentCommissionForm'),
      name: 'agentCommissionEdit',
      meta: {
        title: 'agentMenu.edit_commission_setting', // 編輯AGENT分潤設定
        noCache: false,
        activeMenu: '/market/agentCommission'
      },
      hidden: true
    },
    {
      path: '/market/agentCommissionAdd',
      component: () => import('@/views/spread/agentCommissionForm'),
      name: 'agentCommissionAdd',
      meta: {
        title: 'agentMenu.add_commission_setting', // 新增AGENT分潤設定
        noCache: false,
        activeMenu: '/market/agentCommission'
      },
      hidden: true
    },
    {
      path: '/market/agentCommissionSettlement/detail',
      component: () => import('@/views/market/agentCommissionSettlementDetail'),
      name: 'agentCommissionSettlementDetail',
      meta: {
        title: 'agentMenu.commission_report_detail', // 分潤報表明細
        noCache: false,
        activeMenu: '/market/agentCommissionSettlement'
      },
      hidden: true
    },
    {
      path: '/market/agentCommissionSettlement/batch-update',
      component: () => import('@/views/market/agentCommissionSettlementBatchUpdate'),
      name: 'agentCommissionSettlementBatchUpdate',
      meta: {
        title: 'agentMenu.commission_report_batch_update', // 批次編輯模式
        noCache: true,
        activeMenu: '/market/agentCommissionSettlement'
      },
      hidden: true
    }
  ]
}

export default agentRouter
